<template>
  <div>
    <div class="container">
      <div
        style="
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
      >
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="药材名：">
            <el-input v-model="formInline.keyword"></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="formInline.medicines_type">
              <el-option
                v-for="item in medicines_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="formInline.status">
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="search()">查询</el-button>
      </div>
      <!-- 标题 -->
      <div class="title">
        <div style="display: flex;align-items: center;">
          药材列表
          <el-select
            v-model="formInline.providerData"
            @change="change"
            style="margin-left:20px"
            v-show="isShow"
          >
            <el-option
              v-for="item in providerData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button
            type="text"
            @click="operationLog"
            style="margin-left: 20px;"
            >操作日志</el-button
          >
        </div>
        <div>
          <el-button
            v-show="isProvidersShow"
            type="primary"
            @click="outportData()"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 列表 -->
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="药材名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="standard_type"
          label="是否为新国标"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.standard_type == 1">否</span>
            <span v-else>是</span>
          </template>
        </el-table-column>
        <el-table-column label="关联系统药材" align="center">
          <template slot-scope="scope" v-if="scope.row.shmedicines != null">{{
            scope.row.name +
              scope.row.shmedicines.spec +
              scope.row.unit +
              " /" +
              " g"
          }}</template>
          <template v-else>无</template>
        </el-table-column>
        <el-table-column
          prop="medicines_type_str"
          label="类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="prescription_types_str"
          label="支持剂型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="unit"
          label="单位"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="shmedicines.spec"
          label="单位重量(g)"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="base_price"
          label="基准价(元)"
          align="center"
        ></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status != 0">已下架</span>
            <span v-else>已上架</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="edit(scope.row)"
              >调价</el-button
            >
            <el-button
              v-if="scope.row.status != 0"
              type="text"
              @click="statusEdit(scope.row, 1)"
              >上架</el-button
            >
            <el-button v-else type="text" @click="statusEdit(scope.row, 0)"
              >下架</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :page-count="totalPages"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 调价弹出框 -->
    <el-dialog
      :visible.sync="medicinesVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form
        :model="medicinesForm"
        label-width="120px"
        :rules="medicinesRules"
        ref="ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="药材名称：" prop="name">
              <el-input
                v-model="medicinesForm.name"
                type="text"
                placeholder="请填写药材名称"
                :readonly="readonly"
                >*</el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型：" prop="medicines_type">
              <el-select v-model="medicinesForm.medicines_type" disabled>
                <el-option
                  v-for="item in medicines_type_edit"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位：" prop="unit">
              <el-input
                v-model="medicinesForm.unit"
                type="text"
                placeholder="请填写单位"
                :readonly="readonly"
                >*</el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位重量(g)：" prop="spec">
              <el-input
                v-model="medicinesForm.spec"
                type="text"
                placeholder="请填写单位重量"
                :readonly="readonly"
                >*</el-input
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="基准价(元)：" prop="base_price">
          <el-input
            v-model="medicinesForm.base_price"
            type="text"
            placeholder="请填写基准价"
          >
            <template slot="suffix">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="支持剂型：" prop="prescription_types_str">
          <el-select v-model="medicinesForm.prescription_types_str" disabled>
            <el-option
              v-for="item in prescription_types_str"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联系统药材：" prop="aliases">
          <el-input
            v-model="medicinesForm.aliases"
            type="text"
            placeholder="请填写别名"
            :readonly="readonly"
            >*</el-input
          >
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="medicinesForm.remark"
            type="textarea"
            placeholder="请填写备注"
            >*</el-input
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit()">保 存</el-button>

        <el-button type="primary" @click="medicinesVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!-- 操作日志弹出框1 -->
    <el-dialog
      :visible.sync="operationLogVisible"
      width="50%"
      :close-on-click-modal="false"
      title="操作日志列表"
    >
      <el-table
        :data="operationLogData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="admin_id"
          label="管理员id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="admin_name"
          label="管理员"
          align="center"
        ></el-table-column>
        <el-table-column prop="after_modify_str" label="修改前" align="center">
        </el-table-column>
        <el-table-column prop="pre_modify_str" label="修改后" align="center">
        </el-table-column>
        <el-table-column
          prop="target_id"
          label="修改的id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="target_type_str"
          label="修改的药材"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="修改日期"
          align="center"
        ></el-table-column>
        <el-table-column label="操作类型" align="center">
          <template slot-scope="scope">
            <span>{{ getOperate_type(scope.row.operate_type) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="日志类型" align="center">
          <template slot-scope="scope">
            <span>{{ getTarget_type(scope.row.target_type) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
        ></el-table-column>
      </el-table>

      <div class="pagination" v-if="operation_totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="operation_currentPage"
          :page-size="operation_page_size"
          :page-count="operation_totalPages"
          @current-change="handleOperationPageChange"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/dorisApiConfig";
import { exportMedicineListApi } from "../../../../network/url";
export default {
  name: "medicinemaintenance",
  data() {
    return {
      isShow: false,
      isProvidersShow: false,
      operationLogVisible: false,
      readonly: true,
      keyword: "",
      medicinesVisible: false,
      editTitle: "",
      loading: false,
      formInline: {
        providerData: 0,
      },
      medicinesForm: {},
      tableData: [],
      operationLogData: [],
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      //   操作分页
      operation_currentPage: 1,
      operation_totalPages: 1,
      operation_page_size: 10,
      operation_pageTotal: 10,
      operation_page_index: 10,
      //   excel
      excelData: [],
      excel_current: 1,
      excel_totals: 1,
      form: {
        rule: "十八反",
        rule_type: 1,
      },
      providerData: [],
      meridiansRule: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "十八反",
          label: "十八反",
        },
        {
          value: "十九畏",
          label: "十九畏",
        },
      ],
      unitType: [],
      ruleData: [
        {
          value: "十八反",
          label: "十八反",
        },
        {
          value: "十九畏",
          label: "十九畏",
        },
      ],
      rule_type: [
        {
          value: 1,
          label: "提醒",
        },
        {
          value: 2,
          label: "禁止",
        },
      ],
      out_process: [
        {
          value: 1,
          label: "提醒",
        },
        {
          value: 2,
          label: "禁止",
        },
      ],
      prescription_types_str: [
        {
          value: "免煎颗粒",
          label: "免煎颗粒",
        },
        {
          value: "饮片",
          label: "饮片",
        },
        {
          value: "散剂",
          label: "散剂",
        },
        {
          value: "水丸",
          label: "水丸",
        },
        {
          value: "小蜜丸",
          label: "小蜜丸",
        },
        {
          value: "膏方",
          label: "膏方",
        },
      ],
      medicines_type: [
        {
          value: 1,
          label: "免煎颗粒",
        },
        {
          value: 2,
          label: "饮片",
        },
      ],
      medicines_type_edit: [
        {
          value: 1,
          label: "免煎颗粒",
        },
        {
          value: 2,
          label: "饮片",
        },
      ],
      status: [
        {
          value: 0,
          label: "已上架",
        },
        {
          value: 30,
          label: "已下架",
        },
      ],

      rules: {
        shmedicines_name: [
          { required: true, message: "请填写药材名称1", trigger: "blur" },
        ],
        to_shmedicines_name: [
          { required: true, message: "请选择药材名称2", trigger: "blur" },
        ],
      },
      medicinesRules: {
        name: [{ required: true, message: "请填写药材名称", trigger: "blur" }],
        uuid: [{ required: true, message: "请填写药材编号", trigger: "blur" }],
        unit: [{ required: true, message: "请填写单位", trigger: "blur" }],
        spec: [{ required: true, message: "请选择单位重量", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getProviders();
    this.getData();
    this.getDataPwjj();
  },
  mounted() {
    if (
      localStorage.getItem("providers_id") &&
      localStorage.getItem("providers_id") == 0
    ) {
      this.isShow = true;
    }
    if (
      localStorage.getItem("providers_id") &&
      localStorage.getItem("providers_id") >= 0
    ) {
      this.isProvidersShow = true;
    }
  },
  methods: {
    // 药房药材列表
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
        status: that.formInline.status,
        medicines_type: that.formInline.medicines_type,
        keyword: that.formInline.keyword,
        provider_id: that.formInline.providerData,
      };
      http.get("admin/medicines", { params: params }).then(function(res) {
        that.tableData = res.data.data.medicines;
        that.currentPage = res.data.data.current_page;
        that.totalPages = parseInt(res.data.data.total_pages);
        that.loading = false;
      });
    },
    getProviders() {
      let that = this;
      that.loading = true;
      http.get("admin/select_providers").then(function(res) {
        that.providerData = res.data.data;
        for (let i = 0; i < that.providerData.length; i++) {
          if (that.providerData[i].id == -1) {
            that.providerData.splice(0, 1);
          }
        }
        console.log(that.providerData, "that.providerData");
        that.loading = false;
      });
    },
    change(e) {
      this.formInline.providerData = e;
      this.getData();
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    // 操作日志分页导航
    handleOperationPageChange(val) {
      this.operation_currentPage = val;
      this.getOperationLog();
    },
    // 搜索
    search() {
      this.currentPage = 1;
      this.getData();
    },
    // 操作日志
    operationLog() {
      this.operationLogVisible = true;
      this.getOperationLog();
    },
    getOperate_type(id) {
      if (id == 1) {
        return "修改状态";
      } else if (id == 2) {
        return "修改价格";
      }
    },
    getTarget_type(id) {
      if (id == 1) {
        return "药房药材";
      }
    },
    getOperationLog() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.operation_currentPage,
        page_size: that.operation_page_size,
      };
      http.get("admin/operate_logs", { params: params }).then(function(res) {
        if (res.data.status_code == 200) {
          that.operationLogData = res.data.data.logs;
          that.operation_currentPage = res.data.data.current_page;
          that.operation_totalPages = parseInt(res.data.data.total_pages);
          that.loading = false;
        } else {
          that.$message.warning(res.data.msg);
        }
      });
    },
    // 调价
    edit(row) {
      this.medicinesVisible = true;
      this.editTitle = "药房药材详情页";
      this.medicinesForm = {
        medicine_id: row.medicine_id,
        name: row.name,
        uuid: row.uuid,
        unit: row.unit,
        spec: row.shmedicines.spec,
        aliases: row.name + row.shmedicines.spec + row.unit + " /" + " g",
        base_price: row.base_price,
        about: row.about,
        max_count: row.max_count,
        medicines_type: row.medicines_type,
        out_process: row.out_process,
        prescription_types_str: row.prescription_types_str,
        remark: row.remark,
      };
    },
    saveEdit() {
      let that = this;
      that.loading = true;
      let params = {
        medicines_id: that.medicinesForm.medicine_id,
        base_price: that.medicinesForm.base_price,
        remark: that.medicinesForm.remark,
      };
      http.post("admin/medicine/up_price", params).then(function(res) {
        if (res.data.status_code == 200) {
          that.$message.success("调价成功");
          that.medicinesVisible = false;
          that.getData();
          that.loading = false;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 导出
    // 导出药材列表 请求第一页
    outportData() {
      let provider_id = this.formInline.providerData;
      exportMedicineListApi(provider_id).then((res) => {
        console.log(res, "res");
        // 将文件流转成blob形式
        // const blob = new Blob([res.data], {
        //   type: "application/octet-stream;charset=utf-8",
        // });
        // // const blob = res.data;
        // let filename = "excel" + ".xls";
        // // 创建一个超链接，将文件流赋进去，然后实现这个超链接的单击事件
        // const elink = document.createElement("a");
        // elink.download = filename;
        // elink.style.display = "none";
        // elink.href = URL.createObjectURL(blob);
        // document.body.appendChild(elink);
        // elink.click();
        // URL.revokeObjectURL(elink.href); // 释放URL 对象
        // document.body.removeChild(elink);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 选项卡
    handleClick() {},
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    // 上下架
    statusEdit(row, type) {
      if (type == 0) {
        let that = this;
        // 二次确认删除
        that
          .$confirm("确定要下架吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            let params = {
              medicine_id: row.medicine_id,
              status: 30,
            };
            http.post("admin/medicine/status", params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("下架成功");
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        let that = this;
        // 二次确认删除
        that
          .$confirm("确定要上架吗", "提示", {
            type: "warning",
          })
          .then(() => {
            let params = {
              medicine_id: row.medicine_id,
              status: 0,
            };
            http.post("admin/medicine/status", params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("上架成功");
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.handle-input {
  width: 300px;
  display: inline-block;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 20px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/#tab-1-2 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
